import React from 'react';
import './EmployeeTable.css';
import { FaEdit, FaTrash } from 'react-icons/fa';

const EmployeeTable = ({ employees, onEdit, onDelete, onActivate }) => {
     // Helper to map API fields to table columns
     const renderRows = employees.map((employee) => (
          <tr key={employee.emp_id}>
               <td>{employee.employee_code}</td>
               <td>{employee.employee_name}</td>
               <td>{employee.email}</td>
               <td>{employee.emp_type}</td>
               <td>{employee.department}</td>
               <td>{employee.position || employee.designation || employee.designation_name}</td>
               <td>

                    {(() => {
                         const hasSeparation = Boolean(employee.separation_status);
                         const statusClass = hasSeparation
                              ? `separated ${employee.separation_status.toLowerCase()}`
                              : (employee.status === 'A' ? 'active' : employee.status === 'I' ? 'inactive' : 'unknown');
                         const label = employee.status === 'A' ? 'ACTIVE' : employee.status === 'I' ? 'INACTIVE' : (employee.status || 'UNKNOWN');
                         return (
                              <span className={`status-badge ${statusClass}`}>
                                   {label}{hasSeparation ? ` (${employee.separation_status})` : ''}
                              </span>
                         );
                    })()}
               </td>
               <td>
                    {employee.status === "I" ? (
                         <button
                              className="action-button edit"
                              onClick={() => onActivate && onActivate(employee)}
                         >
                              Activate
                         </button>
                    ) : (
                         <>

                              <button className="action-button edit" onClick={() => onEdit && onEdit(employee)} title="Edit">
                                   <FaEdit />
                              </button>
                              <button className="action-button delete" onClick={() => onDelete && onDelete(employee)} title="Delete">
                                   <FaTrash />
                              </button>
                         </>
                    )}
               </td>
               {/* <td>
                    <button className="action-button edit" onClick={() => onEdit && onEdit(employee)}>Edit</button>
                    <button
                         className="action-button delete"
                         onClick={() => onDelete && onDelete(employee)}
                    >
                         Delete
                    </button>
               </td> */}
          </tr>
     ));

     return (
          <div className="employee-table-container">
               <table className="employee-table">
                    <thead>
                         <tr>
                              <th>EmpCode</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Type</th>
                              <th>Department</th>
                              <th>Position</th>
                              <th>Status</th>
                              <th>Actions</th>
                         </tr>
                    </thead>
                    <tbody>
                         {renderRows}
                    </tbody>
               </table>
          </div>
     );
};

export default EmployeeTable;